import React from 'react'
import './Label.css'

export const Label = (props) =>{
    return(
        <label style={props.style} className={`MSD-Label ${(props.className) ? props.className : ''}`}>
            {props.children}
        </label>
    )
}